module.exports = __webpack_public_path__ + "static/img/rank.10cfe61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/home/rank.png
// module id = o8S6
// module chunks = 0